import * as Constants from "../../constants/urls";
import { useEffect, useState } from "react";
import Pagination from "react-js-pagination";
import { useCookies } from "react-cookie";
import Alerts from "../Alerts";
import axios from "axios";
import "./Table.css";
import Tr from "./Tr";
import UserFilter from "./UserFilters";

export default function UserSearchTable() {
    const [alert, setAlert] = useState(false);
    const [alertType, setAlertType] = useState("alert-success");
    const [alertMassage, setAlertMassage] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(1);
    const [total, setTotal] = useState(1);
    const [searchs, setSearchs] = useState(null);
    const [cookies, setCookie, removeCookie] = useCookies();
    const [loading, setLoading] = useState(false);
    const [filters, setFilters] = useState(false);
    const [searchFilter, setSearchFilter] = useState("");
    const [hasResult, setHasResult] = useState("");

    async function getUserSearchs(page = 1) {
        const url = Constants.apiUrl + `/api/all_user_searchs?page=${page}`;
        await axios
            .get(`${url}`, {
                headers: {
                    Authorization: "Bearer " + cookies.user_server_token,
                },
            })
            .then((response) => {
                console.log(response);
                if (response.data.status == "failed") {
                    // window.location.href = "https://honari.com";

                    setAlertMassage(response.data.message);
                    alert_on();
                    setAlertType("alert-danger");
                } else {
                    setSearchs(response.data.data);
                    setCurrentPage(response.data.current_page);
                    setPerPage(response.data.per_page);
                    setTotal(response.data.total);
                }
            })
            .catch((error) => {
                alert_on();
                setAlertType("alert-danger");
                setAlertMassage("خطایی رخ داده است !");
                console.log(error);
            });
    }

    useEffect(() => {
        getUserSearchs();
    }, []);

    function alert_on() {
        setAlert(true);
    }

    function alert_off() {
        setAlert(false);
    }

    // const handleCloseModal = (event, reason) => {
    //     handleModal();
    // };

    const mp =
        searchs != null &&
        searchs.map((search) => {
            return (
                <Tr
                    key={search.id}
                    id={search.id}
                    search={search.search}
                    userId={search.user_id}
                    link={search.link}
                    hasResult={search.hasResult}
                />
            );
        });

    async function get_items_with_filter(page = 1) {
        const url = Constants.apiUrl + "/api/all_searchs";

        await axios
            .get(
                `${url}?page=${page}&searchFilter=${searchFilter}&hasResult=${hasResult}`,
                {
                    headers: {
                        Authorization: "Bearer " + cookies.user_server_token,
                    },
                },
            )
            .then((response) => {
                console.log(response);
                if (response.data.status == "failed") {
                    // window.location.href = "https://honari.com";

                    alert_on();
                    setAlertType("alert-danger");
                    setAlertMassage(response.data.message);
                } else {
                    setSearchs(response.data.data);
                    setCurrentPage(response.data.current_page);
                    setPerPage(response.data.per_page);
                    setTotal(response.data.total);
                    console.log(response.data);
                }
            })
            .catch((error) => {
                alert_on();
                setAlertType("alert-danger");
                setAlertMassage("خطایی رخ داده است !");
                console.log(error);
            });
    }

    function changeSearch(e) {
        setSearchFilter(e.target.value);
    }

    const changeHasResult = (e) => {
        setHasResult(e.target.value);
    };

    const filterHandler = () => {
        setFilters(!filters);
    };

    return (
        <>
            {alert == true && (
                <Alerts
                    type={alertType}
                    text={alertMassage}
                    close={alert_off}
                />
            )}
            <div className="row">
                <div
                    className="btn  mt-4 py-2 px-4"
                    style={{ margin: "0 auto", border: "1px solid #21222d" }}
                    onClick={filterHandler}
                >
                    فیلتر <strong>{filters ? "↑" : "↓"}</strong>
                </div>
            </div>
            {filters ? (
                <UserFilter
                    apply={get_items_with_filter}
                    changeSearch={changeSearch}
                    search={searchFilter}
                    hasResult={hasResult}
                    changeHasResult={changeHasResult}
                />
            ) : (
                ""
            )}
            <div className="container-fluid">
                <div className="table-responsive mt-5 mb-5">
                    <table className="table table-striped table-hover">
                        <thead className=" ">
                            <tr>
                                <th>شناسه</th>
                                <th>واژه</th>
                                <th>لینک</th>
                                <th>کاربر</th>
                                <th>آیا نتیجه ای داشت؟</th>
                            </tr>
                        </thead>
                        <tbody>{mp}</tbody>
                    </table>
                </div>
                <div className="pager Page navigation example">
                    <Pagination
                        totalItemsCount={total}
                        activePage={currentPage}
                        itemsCountPerPage={perPage}
                        onChange={(number) => {
                            getUserSearchs(number);
                        }}
                        itemClass="page-item"
                        linkClass="page-link"
                        firstPageText="اولین صفحه"
                        lastPageText="آخرین صفحه"
                        nextPageText="بعدی"
                        prevPageText="قبلی"
                        activeClass="pageactive"
                    />
                </div>
            </div>
        </>
    );
}
